import { useState } from "react";
import { Badge, Dropdown, List, ConfigProvider } from "antd";
import NotificationCard from "./NotificationCard";
import useThemeStore from "(store)/themeStore";
import { Tooltip } from "components";
import { BellIcon } from "assets/svg";
import { notificationStore } from "(store)/notificationStore";

export default function NotificationDropdown({
  notifications,
  onExpand,
  handleRedirect,
  setUnreadCount,
}) {
  const [open, setOpen] = useState(false);
  const unReadCount = notificationStore((state) => state.unreadCount);
  const theme = useThemeStore((state) => state.theme);

  const handleClose = () => {
    setOpen(false);
    onExpand();
  };

  const onRedirect = (redirect, isRead, id) => {
    setOpen(false);
    handleRedirect(redirect, isRead, id);
  };

  const NotificationContent = (
    <div className="bg-[#fafafa] dark:bg-gray-800 rounded-lg shadow-lg w-[400px] pt-2 no-scrollbar">
      <List
        dataSource={notifications}
        renderItem={(notification) => (
          <li key={notification.id}>
            <NotificationCard
              notification={notification}
              handleRedirect={onRedirect}
            />
          </li>
        )}
        header={
          <div className="px-4">
            <h4 className="text-lg font-semibold dark:text-alpha text-secondary">
              Notifications
            </h4>
          </div>
        }
        footer={
          <div className="text-center">
            <button
              className="dark:text-white hover:underline text-sm font-medium"
              onClick={handleClose}
            >
              See All
            </button>
          </div>
        }
      />
    </div>
  );

  return (
    <ConfigProvider
      theme={{
        token: {
          colorBgContainer: "#ffffff",
          colorTextBase: "#000000",
        },
        dark: true,
      }}
    >
      <Dropdown
        trigger={["click"]}
        open={open}
        onOpenChange={(open) => {
          setOpen(open);
          if (open) {
            setUnreadCount(0);
          }
        }}
        placement="bottomRight"
        dropdownRender={() => NotificationContent}
      >
        <div className="relative h-14 flex items-center justify-center cursor-pointer">
          <div className="cursor-pointer text-black dark:text-white hover:text-[#1467b0] dark:hover:text-alpha flex items-center justify-center">
            <Badge
              count={unReadCount}
              offset={[-3, 0]}
              style={{
                backgroundColor: theme === "dark" ? "#fab54e" : "#1996a6",
                color: "#fff",
                boxShadow: "none",
              }}
            >
              <Tooltip message="Notifications">
                <BellIcon className="size-6 dark:text-white text-black" />
              </Tooltip>
            </Badge>
          </div>
        </div>
      </Dropdown>
    </ConfigProvider>
  );
}
